import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
import "core-js/modules/web.timers.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/* eslint-disable prefer-destructuring */
import React, { useEffect, useState } from 'react';
import { Button, useIsMounted } from 'components';
import { showApiError } from 'utils';
import { getAnaCreditExports, getAnaCreditExport } from 'services';
import { tableWrap, reportTable, emptyTable } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var AnaCreditExportList = function AnaCreditExportList() {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      exportsList = _useState2[0],
      setExportsList = _useState2[1];

  var isMounted = useIsMounted();
  useEffect(function () {
    fetchAnaCreditExports();
  }, []);

  var fetchAnaCreditExports = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getAnaCreditEx, _yield$getAnaCreditEx2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getAnaCreditExports({
                "export": 0
              });

            case 2:
              _yield$getAnaCreditEx = _context.sent;
              _yield$getAnaCreditEx2 = _slicedToArray(_yield$getAnaCreditEx, 2);
              res = _yield$getAnaCreditEx2[0];
              err = _yield$getAnaCreditEx2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              if (isMounted.current) {
                _context.next = 10;
                break;
              }

              return _context.abrupt("return");

            case 10:
              setExportsList(res);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchAnaCreditExports() {
      return _ref.apply(this, arguments);
    };
  }();

  var exportAnaCredit = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(id) {
      var _yield$getAnaCreditEx3, _yield$getAnaCreditEx4, res, err, headers, filename, matches, a, url;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAnaCreditExport(id);

            case 2:
              _yield$getAnaCreditEx3 = _context2.sent;
              _yield$getAnaCreditEx4 = _slicedToArray(_yield$getAnaCreditEx3, 4);
              res = _yield$getAnaCreditEx4[0];
              err = _yield$getAnaCreditEx4[1];
              headers = _yield$getAnaCreditEx4[3];

              if (!err) {
                _context2.next = 9;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 9:
              filename = 'downloaded-file.zip';

              if (headers['content-disposition']) {
                matches = headers['content-disposition'].match(/filename="(.+)"/);
                if (matches && matches[1]) filename = matches[1];
              }

              a = document.createElement('a');
              document.body.appendChild(a);
              url = URL.createObjectURL(new Blob([res], {
                type: 'application/zip'
              }));
              a.href = url;
              a.download = filename;
              a.click();
              setTimeout(function () {
                window.URL.revokeObjectURL(url);
                document.body.removeChild(a);
              }, 0);

            case 18:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function exportAnaCredit(_x) {
      return _ref2.apply(this, arguments);
    };
  }();

  return ___EmotionJSX("div", {
    css: tableWrap
  }, ___EmotionJSX("table", {
    css: reportTable
  }, ___EmotionJSX("thead", null, ___EmotionJSX("tr", null, ___EmotionJSX("th", null, "ID"), ___EmotionJSX("th", null, "\u0414\u0430\u0442\u0430"), ___EmotionJSX("th", null, "\u0422\u0438\u043F"), ___EmotionJSX("th", null, "\u041F\u043E\u0440\u0435\u0434\u0435\u043D \u0437\u0430 \u0434\u0435\u043D\u044F"), ___EmotionJSX("th", null, "\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435"))), ___EmotionJSX("tbody", null, (exportsList === null || exportsList === void 0 ? void 0 : exportsList.length) > 0 ? exportsList.map(function (el) {
    return ___EmotionJSX("tr", {
      key: el === null || el === void 0 ? void 0 : el.id
    }, ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.id), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.date), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.type), ___EmotionJSX("td", null, el === null || el === void 0 ? void 0 : el.daily_number), ___EmotionJSX("td", null, ___EmotionJSX(Button, {
      small: true,
      type: "info",
      onClick: function onClick() {
        return exportAnaCredit(el === null || el === void 0 ? void 0 : el.id);
      },
      leftIcon: {
        iconName: 'la la-download',
        size: 18
      }
    }, "\u0418\u0437\u0442\u0435\u0433\u043B\u0438")));
  }) : ___EmotionJSX("tr", null, ___EmotionJSX("td", {
    colSpan: 5,
    css: emptyTable
  }, "\u041D\u044F\u043C\u0430 \u0437\u0430\u043F\u0438\u0441\u0430\u043D\u0438 \u0435\u043A\u0441\u043F\u043E\u0440\u0442\u0438.")))));
};

export default AnaCreditExportList;